export default "__VITE_ASSET__DhxVNyb7__";